import { createSlice } from '@reduxjs/toolkit';

// Customer-tasks admin state (Tasks > Customer Tasks screen), mirroring store/colo/coloSlice.js:
// one loading/error surface, list mutations only from thunk success actions.
const initialState = {
  customerTasks: [],
  minerTasks: [],
  isLoading: false,
  error: null
};

const tasksSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    requestStart: state => {
      state.isLoading = true;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    fetchCustomerTasksSuccess: (state, action) => {
      state.customerTasks = action.payload;
      state.isLoading = false;
    },
    createCustomerTaskSuccess: (state, action) => {
      state.customerTasks.unshift(action.payload);
      state.isLoading = false;
    },
    updateCustomerTaskSuccess: (state, action) => {
      state.customerTasks = state.customerTasks.map(task =>
        task.id === action.payload.id ? action.payload : task
      );
      state.isLoading = false;
    },
    deleteCustomerTaskSuccess: (state, action) => {
      state.customerTasks = state.customerTasks.filter(
        task => task.id !== action.payload
      );
      state.isLoading = false;
    },
    fetchMinerTasksSuccess: (state, action) => {
      state.minerTasks = action.payload;
      state.isLoading = false;
    },
    createMinerTaskSuccess: (state, action) => {
      state.minerTasks.unshift(action.payload);
      state.isLoading = false;
    },
    updateMinerTaskSuccess: (state, action) => {
      state.minerTasks = state.minerTasks.map(task =>
        task.id === action.payload.id ? action.payload : task
      );
      state.isLoading = false;
    },
    deleteMinerTaskSuccess: (state, action) => {
      state.minerTasks = state.minerTasks.filter(
        task => task.id !== action.payload
      );
      state.isLoading = false;
    }
  }
});

export const {
  requestStart,
  requestFailure,
  fetchCustomerTasksSuccess,
  createCustomerTaskSuccess,
  updateCustomerTaskSuccess,
  deleteCustomerTaskSuccess,
  fetchMinerTasksSuccess,
  createMinerTaskSuccess,
  updateMinerTaskSuccess,
  deleteMinerTaskSuccess
} = tasksSlice.actions;

export default tasksSlice.reducer;
